/* globals $ */

class PageBuilder {
  blockTypes = [
    "careers-opportunities",
    "articles-slider",
    "get-in-touch-category",
    "get-in-touch-reason",
    "timeline",
    "documents",
    "internal-menu",
    "faqs",
    "faqs-all",
    "categorised-articles",
    "provider-results",
    "provider-invitation",
  ];

  constructor() {
    this.initBlocks();
    console.log("Page Builder initialised");
  }

  initBlocks() {
    this.blockTypes.forEach((type) => {
      if ($(".page-block." + type).length) {
        import(/* webpackChunkName: "[request]" */ `./blocks/${type}`).then(
          (chunk) => {
            $.each($(".page-block." + type), (i, elem) => {
              new chunk.default($(elem));
            });
          },
        );
      }
    });
  }
}

export { PageBuilder };
